import { ApplicationType } from '@squareup/dex-types-shared-application-type';

const sandboxModeHeaders = (applicationType: ApplicationType): HeadersInit => {
  const sandboxModeHeaderName = 'sandbox-mode';

  const sandboxModeHeaderValue =
    applicationType === ApplicationType.Sandbox ? 'true' : 'false';

  return {
    [sandboxModeHeaderName]: sandboxModeHeaderValue,
  };
};

interface OnlyApplicationType {
  applicationType: ApplicationType;
}

interface OnlyApplicationId {
  applicationId: string;
}

type OnlyApplicationProps = OnlyApplicationType & OnlyApplicationId;

type WithApplicationType<T> = T & OnlyApplicationType;
type WithApplicationId<T> = T & OnlyApplicationId;
type WithApplicationProps<T> = T & OnlyApplicationProps;

export {
  sandboxModeHeaders,
  type OnlyApplicationType,
  type OnlyApplicationId,
  type OnlyApplicationProps,
  type WithApplicationType,
  type WithApplicationId,
  type WithApplicationProps,
};
